export default "__VITE_ASSET__BiswerR2__"